import { css } from '@emotion/react';
import { AnalyticsHooks } from '@frontend/analytics-shared';
import { LocationChip } from '@frontend/analytics-shared';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';
import { nsrTimePeriods } from './filters';

interface Props {
  endDate?: string;
  locationId: string;
  startDate?: string;
}

export const MutliChartTooltipTitle = ({ endDate, locationId, startDate }: Props) => {
  const { locationNames } = AnalyticsHooks.useAnalyticsOrgLocations({
    module: 'ROI',
  });

  const timePeriod =
    startDate && endDate
      ? AnalyticsHooks.findExistingTimePeriodKey<typeof nsrTimePeriods>(startDate, endDate, nsrTimePeriods) ?? undefined
      : undefined;

  return (
    <div css={styles.wrapper}>
      <LocationChip locationName={locationNames?.[locationId]} />
      {timePeriod && (
        <Chip leftElement={<Icon name='calendar-small' />} variant='neutral'>
          {nsrTimePeriods?.[timePeriod]?.label}
        </Chip>
      )}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
  `,
};
